import React from "react";
import { Stack } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import "../../context/context_components/context_components.css";
import { contextBuilderActions } from "../../store/store";

export const Projects = () => {
  const { projectInfo, dateTime } = useSelector(state => state.projectInfoStore);
  const {
    color
  } = useSelector(state => state.themeStore);
  //const { page } = useSelector(state => state.contextBuilderStore); 
  //const dispatch = useDispatch();

 

  return (
    <Stack
      direction="row"
      className="project-info-dark"
      sx={{
        color: color
      }}
      
    >
      <span>{projectInfo[0]}</span>
      <span>{dateTime}</span>
      <span>{projectInfo[1]}</span>
    </Stack >
  )
}